import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var GetTransactionListCtrl = function (fn, er, state, typeCall, token, ids) {
	var config = {
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},
	};
	var data = {
		day: state.selectedDay,
		maxAmount: state.maxamount,
		maxNetAmount: state.maxamountnet,
		minAmount: state.minamount,
		minNetAmount: state.minamountnet,
		month: state.selectedMonthYear,
		codPos: state.codepv,
		pos: state.codpos,
		closedOnly: state.selectedMov,
		orderBy: "",
		typeCall: typeCall === undefined ? "X" : typeCall,
		page: state.currentPage
	};

	axios
		.post(ApiConfig.url.GET_TRANSACTION_LIST, data, config)
		.then(function (result) {
			console.log(result)
			fn(result.data, result.status)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { GetTransactionListCtrl };